document.addEventListener('variant:change', (event) => {
  const container = document.querySelector('[data-pick-up-store]');

  setTimeout(() => {
    const selectFrom = document.querySelector('.store-availability__info > div');
    const newText = selectFrom.innerHTML.replace('Hent i butikk på', '').trim();

    container.innerHTML = ':' + ' ' + newText;
  }, 500);

});

document.addEventListener("DOMContentLoaded", () => {
  let totalInCart = 0;
  let requiredValue = 0;
  let progressBar = null;

  // Function to cache DOM elements
  function cacheDOMElements() {
    return {
      cartItemsEl: document.querySelector(".cart__items"),
      progressBarContainer: document.querySelector(
        ".drawer__cart-progress-bar"
      ),
      progressBarSlider: document.querySelector(
        ".drawer__cart-progress-bar-item-slider-bar"
      ),
      progressBarText: document.querySelector(
        ".drawer__cart-progress-bar-item-text"
      ),
    };
  }

  function updateProgress() {
    const {
      cartItemsEl,
      progressBarContainer,
      progressBarSlider,
      progressBarText,
    } = cacheDOMElements();

    if (
      !cartItemsEl ||
      !progressBarContainer ||
      !progressBarSlider ||
      !progressBarText
    ) {
      console.error("Required elements not found in the DOM.");
      return;
    }

    // Retrieve and parse numeric values
    totalInCart =
      parseFloat(cartItemsEl.getAttribute("data-cart-subtotal")) || 0;
    requiredValue =
      parseFloat(progressBarContainer.getAttribute("data-required-value")) || 0;

    if (requiredValue === 0) {
      console.error("Required value for free shipping is not set.");
      return;
    }

    console.log("totalInCart", totalInCart);

    // Calculate remaining amount
    const remaining = (requiredValue - totalInCart) / 100;
    const progress = Math.min((totalInCart / requiredValue) * 100, 100);

    // Update the text
    if (remaining > 0) {
      progressBarText.innerHTML = `Du er kr ${remaining.toFixed(
        2
      )},- fra fri frakt`;
    } else {
      progressBarText.innerHTML = `Gratulerer! Du har oppnådd fri frakt.`;
    }

    if (totalInCart > 0) {
      progressBarContainer.style.display = "flex";
    } else {
      progressBarContainer.style.display = "none";
    }

    // Update the progress bar
    progressBarSlider.style.width = `${progress}%`;

    console.log("progress", progress);
  }

  // Event listeners
  document.addEventListener("drawerOpen", () => {
    setTimeout(updateProgress, 1000);
  });

  document.addEventListener("cart:updated", () => {
    setTimeout(updateProgress, 1000);
  });

  // Initial update in case the drawer is already open
  updateProgress();
});




document.addEventListener("DOMContentLoaded", function () {
  const showMoreLink = document.getElementById("showMoreVariants");
  if (showMoreLink) {
    showMoreLink.addEventListener("click", function () {
      document.querySelectorAll(".hidden-variant").forEach(function (variant) {
        variant.style.display = "block"; // or variant.classList.remove('hidden-variant');
      });
      showMoreLink.style.display = "none"; // Hide the link after expanding
    });
  }
});






document.addEventListener("DOMContentLoaded", () => {
  const content = document.getElementById("description-content");
  const text = document.getElementById("description-text");
  const expandLink = document.getElementById("expand-link");

  // Only run if all elements are found
  if (!content || !text || !expandLink) return;

  // Add toggle behavior
  expandLink.addEventListener("click", (event) => {
    event.preventDefault(); // prevent anchor jump

    if (expandLink.textContent.trim() === "Vis mer") {
      expandLink.textContent = "Vis mindre";
      text.classList.remove("text-clip");
    } else {
      expandLink.textContent = "Vis mer";
      text.classList.add("text-clip");
    }
  });

  // Detect overflow and show/hide the link
  if (text.scrollHeight > content.offsetHeight) {
    expandLink.style.display = "inline";
  } else {
    expandLink.style.display = "none";
  }
});

// Keep the mobile product-card gallery in sync
// when a color swatch changes.

document.addEventListener("change", (event) => {

  const swatchInput = event.target.closest(
    'product-card .product-card__info input[type="radio"][data-variant-media]'
  );

  if (!swatchInput) return;

  const productCard = swatchInput.closest("product-card");

  const carousel = productCard?.querySelector(
    ".product-card__mobile-carousel"
  );

  if (!carousel || typeof carousel.select !== "function") {
    return;
  }

  try {

    const variantMedia = JSON.parse(
      swatchInput.getAttribute("data-variant-media")
    );

    const slide = carousel.querySelector(
      `[data-media-id="${variantMedia.id}"]`
    );

    if (!slide) return;

    const slideIndex = carousel.cells.indexOf(slide);

    if (slideIndex >= 0) {
      carousel.select(slideIndex);
    }

  } catch (error) {

    console.warn(
      "Could not sync mobile product-card gallery.",
      error
    );

  }

});